'use strict';

exports.__esModule = true;
var SPECIALTIES = exports.SPECIALTIES = {
  MAIN_SPECIALTIES: {
    LOADING: 'MAIN_SPECIALTIES_LOADING',
    SUCCEEDED: 'MAIN_SPECIALTIES_SUCCEEDED',
    FAILED: 'MAIN_SPECIALTIES_FAILED'
  },
  SUB_SPECIALTIES: {
    LOADING: 'SUB_SPECIALTIES_LOADING',
    SUCCEEDED: 'SUB_SPECIALTIES_SUCCEEDED',
    FAILED: 'SUB_SPECIALTIES_FAILED'
  }
};

var loadMainSpecialties = exports.loadMainSpecialties = function loadMainSpecialties(culture /*: string*/) {
  return {
    type: SPECIALTIES.MAIN_SPECIALTIES.LOADING,
    culture: culture
  };
};

var loadSubSpecialties = exports.loadSubSpecialties = function loadSubSpecialties(mainSpecialty /*: string*/) {
  return {
    type: SPECIALTIES.SUB_SPECIALTIES.LOADING,
    mainSpecialty: mainSpecialty
  };
};